import { formatStr } from '@/utils/utils';
import { Modal, Table, Tooltip, Popover, Spin } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import styles from './index.module.less';
import { getMaterialVersions, updateMaterialVersion } from '@/services/source';
import { EmptyShaderColor } from 'patternx-svg';

interface CardInfoProps {
  data: SOURCE.Material;
  // view: Function;
  visible: boolean;
  onCancel: () => void;
  init: () => void;
  onDown: Function;
}

export default React.memo((props: CardInfoProps) => {
  const { data, visible, onCancel, init, onDown } = props;
  const [versions, setVersions] = useState<ELEMENT.VersionItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const getVersions = async () => {
    const res = await getMaterialVersions(data?.id);
    if (res?.success) {
      const details = res?.data?.details || [];
      setVersions(details);
    }
    setIsLoading(false);
  };

  const handleSetCurrentVersion = async (materialId: string, materialVersionId: string) => {
    const res = await updateMaterialVersion(materialId, materialVersionId);
    if (res?.success) {
      getVersions();
      init();
    }
  };

  useEffect(() => {
    getVersions();
  }, []);

  // const onView = (row: any) => {
  //   view({
  //     ...row,
  //     currentVersionId: row.materialVersionId,
  //   });
  // };

  const columns = [
    {
      title: '文件名称',
      dataIndex: 'name',
      key: 'name',
      render: (_text: any, row: any) => {
        return (
          <div className="flex-ai-center">
            <Tooltip title={_text}>
              <span
                className="ellipsis_txt"
                style={{ maxWidth: row?.currentVersion ? '140px' : '200px' }}
              >
                {/* {row.currentVersion ? formatStr(_text, 10) : formatStr(_text, 15)} */}
                {_text}
              </span>
            </Tooltip>
            {row.currentVersion && <span className={styles.tag}>当前版本</span>}
          </div>
        );
      },
    },
    {
      title: '上传人',
      dataIndex: 'uploadBy',
      key: 'uploadBy',
      width: 80,
    },
    {
      title: '上传日期',
      dataIndex: 'uploadAt',
      key: 'uploadAt',
      width: 120,
      render: (val: string) => {
        return moment(val).format('YYYY.M.D');
      },
    },
    {
      title: '版本号',
      dataIndex: 'version',
      key: 'version',
      width: 80,
      render: (val: string) => {
        return <span className={styles.version}>{`V${val}`}</span>;
      },
    },
    {
      title: '操作',
      key: 'action',
      width: 210,
      dataIndex: 'action',
      render: (_val: string, row: any) => {
        return (
          <div>
            <Popover
              placement="bottom"
              title={null}
              destroyTooltipOnHide={true}
              content={
                <div className={styles.img}>
                  {row?.ballThumbnailUrl ? (
                    <img src={row?.ballThumbnailUrl} />
                  ) : (
                    <EmptyShaderColor size={160} />
                  )}
                </div>
              }
            >
              <span key="view" className="table-btn">
                查看
              </span>
            </Popover>
            <span
              key="download"
              className="table-btn"
              onClick={() => {
                onDown(row, 'version');
              }}
            >
              下载
            </span>
            {!row.currentVersion && (
              <span
                key="set"
                className="table-btn"
                onClick={() => handleSetCurrentVersion(row.materialId, row.materialVersionId)}
              >
                设为主版本
              </span>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <Modal
      title="版本管理"
      visible={visible}
      width={800}
      bodyStyle={{
        padding: '14px 18px 14px 22px',
        minHeight: '200px',
        maxHeight: '400px',
        overflowY: 'auto',
      }}
      footer={null}
      onCancel={onCancel}
      centered={true}
    >
      <div>
        {isLoading ? (
          <Spin className={styles.spin} />
        ) : (
          <Table
            rowKey="materialVersionId"
            columns={columns}
            dataSource={versions}
            pagination={false}
          />
        )}
      </div>
    </Modal>
  );
});
